export const environmentBase = {
  production: false,
  apiUrl: 'http://localhost:3000/api',
  googleAnalyticsID: '',
  recaptchaSiteKey: '',
};
